/**
 * Apply Page — `/apply/:inviteId` and `/co-applicant/apply/:inviteId`
 *
 * On mobile (Android / iOS / iPad), if Universal Links / App Links did not open
 * the native app, show a chooser: install via the correct store badge, or
 * continue registration on the web. Desktop users go straight to the form.
 */
import { useMemo, useState } from 'react'
import { VerifyInfoSetPassword } from '@/features/auth/pages/VerifyInfoSetPassword'
import { MobileAppChooser } from '../components/MobileAppChooser'
import { detectMobilePlatform } from '../utils/detectMobilePlatform'
import type { ApplyPageProps } from '../types'

export function ApplyPage({ isCoApplicant = false }: ApplyPageProps) {
  const platform = useMemo(() => detectMobilePlatform(), [])
  const [continueOnWeb, setContinueOnWeb] = useState(false)

  if (platform && !continueOnWeb) {
    return (
      <MobileAppChooser
        platform={platform}
        onContinueOnWeb={() => setContinueOnWeb(true)}
      />
    )
  }

  return <VerifyInfoSetPassword isCoApplicant={isCoApplicant} />
}
